import { useEffect, useRef } from 'react';

export default function Ticker() {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Clear previous content
    container.innerHTML = '';

    // Create widget container structure
    const widgetContainer = document.createElement('div');
    widgetContainer.className = 'tradingview-widget-container';

    const widgetDiv = document.createElement('div');
    widgetDiv.className = 'tradingview-widget-container__widget';
    widgetContainer.appendChild(widgetDiv);

    // Create and configure the script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js';
    script.async = true;
    script.textContent = JSON.stringify({
      symbols: [
        { proName: "FX_IDC:USDCOP", title: "USD/COP" },
        { proName: "FX_IDC:COPUSD", title: "COP/USD" },
        { proName: "FOREXCOM:USDMXN", title: "USD/MXN" },
        { proName: "FX_IDC:COPMXN", title: "COP/MXN" },
        { proName: "FX_IDC:USDARS", title: "USD/ARS" },
        { proName: "FX_IDC:COPARS", title: "COP/ARS" },
        { proName: "FX_IDC:USDCLP", title: "USD/CLP" },
        { proName: "FX_IDC:COPCLP", title: "COP/CLP" },
        { proName: "FX_IDC:USDBRL", title: "USD/BRL" },
        { proName: "FX_IDC:COPBRL", title: "COP/BRL" },
        { proName: "FX_IDC:USDPEN", title: "USD/PEN" },
        { proName: "FX_IDC:COPPEN", title: "COP/PEN" }
      ],
      showSymbolLogo: false,
      isTransparent: true,
      displayMode: "compact",
      colorTheme: "dark",
      locale: "es"
    });

    widgetContainer.appendChild(script);
    container.appendChild(widgetContainer);

    return () => {
      container.innerHTML = '';
    };
  }, []);

  /* Misma caja que el header: w-[95%] max-w-7xl (80rem) + px-4 lg:px-8 */
  const fadeGutter =
    'w-[calc((100vw_-_min(95vw,80rem))_/_2_+_1rem)] lg:w-[calc((100vw_-_min(95vw,80rem))_/_2_+_2rem)]';

  return (
    <section className="relative overflow-hidden bg-transparent" aria-label="Cotizaciones de divisas en tiempo real">
      <div className="absolute top-0 left-0 right-0 h-px z-20" style={{ background: 'linear-gradient(90deg, transparent, #A84397, #D23CB3, #A84397, transparent)', opacity: 0.35 }} />
      <div className="absolute bottom-0 left-0 right-0 h-px z-20" style={{ background: 'linear-gradient(90deg, transparent, #A84397, #D23CB3, #A84397, transparent)', opacity: 0.35 }} />
      <div
        className={`pointer-events-none absolute inset-y-0 left-0 z-20 ${fadeGutter}`}
        style={{
          background: 'linear-gradient(to right, #0a090c 0%, rgba(10,9,12,0.88) 55%, transparent 100%)',
        }}
      />
      <div
        className={`pointer-events-none absolute inset-y-0 right-0 z-20 ${fadeGutter}`}
        style={{
          background: 'linear-gradient(to left, #0a090c 0%, rgba(10,9,12,0.88) 55%, transparent 100%)',
        }}
      />
      <div ref={containerRef} className="w-full" />
    </section>
  );
}
